import { render, flushSync } from "react-dom";
import { renderToStaticMarkup } from "react-dom/server";

// See the following for why we aren't simply using renderToStaticMarkup
// https://react.dev/reference/react-dom/server/renderToStaticMarkup#caveats
export function renderStaticJsxToString(jsx: JSX.Element) {
  // Check if we're in a browser environment
  if (typeof window !== "undefined" && window.document) {
    const div = document.createElement("div");

    flushSync(() => {
      render(jsx, div);
    });

    return div.innerHTML;
  } else {
    // Server-side rendering
    return renderToStaticMarkup(jsx);
  }
}
